<template>
  <ion-menu menu-id="app-menu" content-id="main-content">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <div class="flex items-center pl-16">
          <ion-menu-toggle>
            <ion-button
              fill="solid"
              size="small"
              color="secondary"
              shape="round"
            >
              <ion-icon slot="icon-only" :icon="close" />
            </ion-button>
          </ion-menu-toggle>
          <img src="/images/SH-logo.png" class="h-40 pl-16 my-16">
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item button @click="routing('/dashboard')">
          <ion-icon
            slot="start"
            aria-hidden="true"
            :icon="activeTabName === 'dashboard' ? home : homeOutline"
            class="w-24 h-24"
            :class="{
              'text-primary-default': activeTabName === 'dashboard',
            }"
          />
          <ion-label>Hem</ion-label>
        </ion-item>
        <ion-item
          v-if="!groupsHidden"
          button
          @click="routing('/groups')"
        >
          <ion-icon
            slot="start"
            aria-hidden="true"
            :icon="activeTabName === 'groups' ? chatbubbles : chatbubblesOutline"
            class="w-24 h-24"
            :class="{
              'text-primary-default': activeTabName === 'groups',
            }"
          />
          <ion-label>Grupper</ion-label>
        </ion-item>
        <ion-item
          v-if="!checklistsHidden"
          button
          @click="routing('/checklists')"
        >
          <ion-icon
            slot="start"
            aria-hidden="true"
            :icon="activeTabName === 'checklists' ? list : listOutline"
            class="w-24 h-24"
            :class="{
              'text-primary-default': activeTabName === 'checklists',
            }"
          />
          <ion-label>Tips & råd</ion-label>
        </ion-item>
        <ion-item
          v-if="!warningsHidden"
          button
          @click="routing('/warnings')"
        >
          <ion-icon
            slot="start"
            aria-hidden="true"
            :icon="activeTabName === 'warnings' ? warning : warningOutline"
            class="w-24 h-24"
            :class="{
              'text-primary-default': activeTabName === 'warnings',
            }"
          />
          <ion-label>Varningar</ion-label>
        </ion-item>
        <ion-item
          v-if="!reportHidden"
          button
          @click="startReport"
        >
          <ion-icon
            slot="start"
            aria-hidden="true"
            :icon="addCircle"
            class="w-24 h-24 text-primary-default"
          />
          <ion-label>Anmäl</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>
</template>
<script setup lang="ts">
import {
  addCircle,
  chatbubbles,
  chatbubblesOutline,
  home,
  homeOutline,
  list,
  listOutline,
  warning, warningOutline,
  close
} from 'ionicons/icons';
import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenu,
  IonToolbar,
  menuController,
  useIonRouter,
  IonMenuToggle,
  IonItem,
  IonList
} from '@ionic/vue';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { useIncidentStore } from '@/store/incident';
import { useFeatureVisibility } from '@/composeables/useFeatureVisibility';

const route = useRoute();
const incidentStore = useIncidentStore();
const ionRouter = useIonRouter();
const { reportHidden, groupsHidden, checklistsHidden, warningsHidden } = useFeatureVisibility();
const activeTabName = computed(() => {
  return route.matched[1] && route.matched[1].path.split('/')[1] || '';
});

const routing = (route: string) => {
  menuController.close('app-menu');
  ionRouter.push(route);
};

const startReport = () => {
  menuController.close('app-menu');
  incidentStore.openIncidentModal();
};
</script>
